import React, { forwardRef, MouseEvent } from "react";

import { ForwardRefType } from "@multiweb/types/react";
import { ButtonProvider, ButtonProviderProps } from "../ButtonProvider";
import { Icon, IconProps } from "../Icon";
import { Layout, SpacingSize } from "../Layout";
import { Text } from "../Text";
import { IconTextColor } from "./enums";
import { getIconColor, getTextColor } from "./utils";

export type IconTextButtonProps = {
    /** Popisek pro bližší popis tlačítka */
    title?: string;
    /** Barva ikony a textu */
    color?: IconTextColor;
    /** Callback volaný na kliknutí */
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
    /** Text tlačítka */
    value: string;
} & Omit<ButtonProviderProps, "title" | "onClick" | "theme"> & Omit<IconProps, "title" | "color" | "size">;

/** Tlačítko v podobě ikony a textu */
export const IconTextButton: ForwardRefType<HTMLButtonElement, IconTextButtonProps> = forwardRef<HTMLButtonElement, IconTextButtonProps>(({
    title,
    color = IconTextColor.colorPrimary,
    onClick,
    backgroundColor,
    isFocused,
    tabIndex,
    disabled,
    shadow,
    outline,
    ...restProps
}, ref) => (
    <ButtonProvider {...{ onClick, title, ref, disabled, tabIndex, isFocused, shadow, outline, backgroundColor }}>
        <Layout spacingSizeVertical={SpacingSize.xs} spacingSizeLeft={SpacingSize.xs}>
            <Icon color={getIconColor(color)} disabled={disabled} {...restProps} />
        </Layout>
        <Layout spacingSize={SpacingSize.xs}>
            <Text color={getTextColor(color)} disabled={disabled} isTextSelectable={false} {...restProps} />
        </Layout>
    </ButtonProvider>
));
